import get from 'lodash/get';

export const CreditCardServiceModule = angular
    .module('app.services.payment.stripe', [])
    .service('creditCardService', ($q, $window) => {
        function createStripeCcToken(card, user, billingAddress) {
            let deferred = $q.defer();
            let payload = {
                number: card.cardNumber,
                cvc: card.CVV,
                exp: card.expiration,
                name: `${user.firstName} ${user.lastName}`
            };
            if (billingAddress) {
                angular.extend(payload, {
                    address_line1: billingAddress.address1,
                    address_line2: billingAddress.address2,
                    address_city: billingAddress.city,
                    address_state: billingAddress.state,
                    address_zip: billingAddress.postalCode
                });
            }

            $window.Stripe.setPublishableKey(process.env.MERCHANT_STRIPE_PUBLISHABLE_KEY);
            $window.Stripe.card.createToken(payload, (status, response) => {
                if (response.error) {
                    deferred.reject(response.error);
                } else {
                    deferred.resolve(response);
                }
            });
            return deferred.promise;
        }

        function getStripe() {
            return $window.Stripe(process.env.MERCHANT_STRIPE_PUBLISHABLE_KEY); //eslint-disable-line
        }

        function createAuthorizeNetCcToken(card, user, billingAddress, authorizeNet) {
            const postalCode = billingAddress.postalCode;
            const expStringParts = card.expiration.split('/');
            const expMonth = expStringParts[0];
            const expYear = expStringParts[1].substring(2, 4) || expStringParts[1];

            const cardPayload = {
                authData: {
                    clientKey: authorizeNet.publicClientKey,
                    apiLoginID: authorizeNet.apiLoginId
                },
                cardData: {
                    cardNumber: card.cardNumber,
                    month: expMonth,
                    year: expYear,
                    cardCode: card.CVV,
                    zip: postalCode,
                    fullName: `${user.firstName} ${user.lastName}`
                }
            };

            const deferred = $q.defer();
            const authorizeNetCallback = (data) => {
                const error = getAuthorizeNetError(data);
                if (error) {
                    deferred.reject(error);
                } else {
                    deferred.resolve(data);
                }
            };
            $window.Accept.dispatchData(cardPayload, authorizeNetCallback);
            return deferred.promise;
        }

        function getAuthorizeNetError(data) {
            if (data.error) {
                return data.error;
            }
            if (get(data, 'messages.resultCode') === 'Error') {
                const message = `${get(data, 'messages.message[0].code')}: ${get(data, 'messages.message[0].text')}`;
                return { data: { message } };
            }
            const opaqueValue = get(data, 'opaqueData.dataValue');
            const opaqueDescriptor = get(data, 'opaqueData.dataDescriptor');
            if (!(opaqueValue && opaqueDescriptor)) {
                return { data: { message: 'Could not get valid credit card token from Authorize.net.' } };
            }
            return null;
        }

        function canUsePaymentRequestAPI() {
            const paymentRequest = this.getStripe().paymentRequest({
                country: 'US',
                currency: 'usd',
                total: {
                    label: 'Stub',
                    amount: 0
                }
            });
            // Check the availability of the Payment Request API.
            return paymentRequest.canMakePayment().then((result) => {
                return result !== null && result !== undefined;
            });
        }

        function getSupportedPaymentRequestPlatforms() {
            const paymentRequest = this.getStripe().paymentRequest({
                country: 'US',
                currency: 'usd',
                total: {
                    label: 'Stub',
                    amount: 0
                }
            });
            // Check the availability of the Payment Request API.
            return paymentRequest.canMakePayment();
        }

        return {
            createAuthorizeNetCcToken,
            createStripeCcToken,
            getAuthorizeNetError,
            getStripe,
            canUsePaymentRequestAPI,
            getSupportedPaymentRequestPlatforms
        };
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/services/payment/stripe/creditCard.service.js